import { Component, OnInit, Output, EventEmitter, Input, SimpleChanges } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AllocationService } from 'src/app/pages/allocation/allocation.service';
import { debounceTime, filter, distinctUntilChanged, map, tap } from 'rxjs/operators';
import { DialogService, LanguageService, HelperService } from 'src/app/services';
import { environment } from 'src/environments/environment';
import { of as observableOf, Subscription } from 'rxjs';
import * as moment from "moment";
import * as _ from 'lodash';

@Component({
  selector: 'esc-campaign-distribution-selector',
  templateUrl: './campaign-distribution-selector.component.html',
  styleUrls: ['./campaign-distribution-selector.component.scss']
})
export class CampaignDistributionSelectorComponent implements OnInit {
  @Input() textLabel;
  @Input() wrapperLayoutAlign;
  @Input() labelFlex;
  @Input() formWrapperFlex;
  @Input() selectedCampaign;
  @Input() allocationLevel;
  @Output() campaignDistributionSelected = new EventEmitter;
  
  form: FormGroup;
  originals = [];
  loading = {
    campaign_distribution: false,
    init: false,
    more: false,
    error: false
  };
  public listData = [];
  private currentFilters;
  networkErrMsg = this.languageService.getTranslation("MSG_ERROR_NETWORK_CONNECTION", {});

  constructor(
    private fb: FormBuilder,
    private helper: HelperService,
    public allocSvc: AllocationService,
    private dialogService: DialogService,
    private languageService: LanguageService,
    ) { }

  ngOnInit() {
    this.currentFilters = _.cloneDeep(INITIAL_OPTIONS);
    this.initForm();
    this.detectFormChanges();
  }

  ngOnDestroy() {}

  initForm() {
    this.form = this.fb.group({
      campaign_distribution: [null, [Validators.required, this.helper.checkIfObject]]
    })

    if(this.selectedCampaign) {
      console.log(this.selectedCampaign)
      this.form.get('campaign_distribution').setValue(this.selectedCampaign);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if(changes && changes.selectedCampaign && !changes.selectedCampaign.firstChange) {
      this.form.get('campaign_distribution').setValue(changes.selectedCampaign.currentValue, {emitEvent: false});
    }
  }

  detectFormChanges() {
    this.form.get('campaign_distribution').valueChanges.pipe(
      debounceTime(600),
      filter((term) => !_.isObject(term)),
      distinctUntilChanged(),
      map((term: string) => _.trim(term)),
    )
    .subscribe(value => {
      this.currentFilters.web_filter.keyword = _.toString(value);
      this.listData = [];
      this.getListData();
    });
  }

  getInitialValues(data) {
    this.currentFilters.web_filter.offset = 0;
    this.currentFilters.web_filter.keyword = "";
    this.getListData();
  }

  getListData() {
    this.loading.campaign_distribution = true;
    if (this.loading.init == true) {
      return;
    }
    this.loading.error = false;
    if (this.listData.length == 0) {
      this.loading.init = true;
    } else {
      this.loading.more = true;
    }

    this.allocSvc.getCampaignDistributionList(this.allocationLevel, this.currentFilters)
      .subscribe((res: any) => {
        if (environment.showLogs) {
          console.log(res);
        }
        this.loading.campaign_distribution = false;
        this.loading.init = false;
        this.loading.more = false;
        if (res == null || res.status == 0 || res.status == 400 || res.status == 500 || res.status == 502 || res.status == 504) {
          this.loading.error = true;
          this.listData = [];
          this.dialogService.openSnackBar(this.networkErrMsg)
          return;
        }
        if (_.has(res, 'value') && (res.value == "Success")) {
          this.listData = this.listData.concat(res.data);
        } else {
          this.listData = [];
        }
      }, err => {
        if (environment.showLogs) {
          console.error(err);
        }
        this.loading.campaign_distribution = false;
        if (this.listData.length == 0) {
          this.loading.error = true;
        } else {
          this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_INTERNAL_SERVER_ERROR", {}));
          this.currentFilters.web_filter.limit -= this.currentFilters.web_filter.offset;
        }
        return observableOf(null);
      });
  }

  displayFn(data?: any): string | undefined {
    if(data) {
      return _.get(data, 'campaign_code') + '-' + _.get(data, 'campaign_description') + ' -- ' + _.get(data, 'distribution_code') + '-' + _.get(data, 'distribution_description');
    }
    return null;
  }

  autoCmpltClosed() {
    this.listData = [];

    if (_.has(this.form.get('campaign_distribution'), 'value') && _.isObject(_.get(this.form.get('campaign_distribution'), 'value'))) {
      this.campaignDistributionSelected.next(_.get(this.form.get('campaign_distribution'), 'value'));
    }
  }

  clearForm(ev: Event) {
    this.listData = [];
    this.form.get('campaign_distribution').setValue(null, {emitEvent: false});
    this.campaignDistributionSelected.next(null);
    ev.stopPropagation();
  }
}

const INITIAL_OPTIONS = {
  web_filter: {
    offset: 0,
    limit: 50,
    keyword: "",
    status: [0],
    distribution_start_date: "",
    distribution_end_date: "",
    getMore: true
  }
}